import isEqual from 'lodash.isequal';
import { EndPoints } from '../../common/enums/enums';
import { api } from './api';

export const invalidateQuery = body => {
  const filters = { ...body };
  delete filters.pageNumber;
  return api.internalActions.removeQueryResult({
    queryCacheKey: `getVehicleOrders(${JSON.stringify(filters)})`,
  });
};

export const ordersServices = api.injectEndpoints({
  endpoints: build => ({
    getVehicleOrders: build.query({
      query: body => ({
        url: EndPoints.ORDERS.BY_VEHICLE,
        method: 'POST',
        body,
      }),
      serializeQueryArgs({ endpointName, queryArgs }) {
        const filters = { ...queryArgs };
        delete filters.pageNumber;
        return `${endpointName}(${JSON.stringify(filters)})`;
      },
      forceRefetch({ currentArg, previousArg }) {
        if (!previousArg) return true;

        return (
          !isEqual(
            { ...currentArg, pageNumber: 1 },
            { ...previousArg, pageNumber: 1 }
          ) || currentArg.pageNumber > previousArg.pageNumber
        );
      },
      merge: (currentData, responseData) => {
        currentData.pagination = responseData.pagination;
        (responseData.pagination.pageNumber > 1 &&
          currentData.vehicleOrders.push(...responseData.vehicleOrders)) ||
          (currentData.vehicleOrders = responseData.vehicleOrders);
      },
      keepUnusedDataFor: 5,
    }),
    declineAndApproveOrder: build.mutation({
      query: ({
        declinedServiceIds,
        approvedServiceIds,
        observation,
        orderId,
      }) => ({
        url: EndPoints.ORDERS.PATCH.replace('{orderId}', orderId),
        method: 'PATCH',
        body: {
          declinedServiceIds,
          approvedServiceIds,
          observation,
        },
      }),
    }),
    repairOrders: build.mutation({
      query: ({ orderId, repairOrder }) => ({
        url: EndPoints.ORDERS.PATCH.replace('{orderId}', orderId),
        method: 'PATCH',
        body: {
          repairOrder,
        },
      }),
    }),
    signOffWorkOrder: build.mutation({
      query: ({ orderId, body }) => ({
        url: EndPoints.ORDERS.SIGNOFF_WORK_ORDER.ENDPOINT.replace(
          '{orderId}',
          orderId
        ),
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const {
  useSignOffWorkOrderMutation,
  useGetVehicleOrdersQuery,
  useDeclineAndApproveOrderMutation,
  useRepairOrdersMutation,
} = ordersServices;
